export default __webpack_public_path__ + "static/media/Florence 9781408312384.8273e7cb.jpg";